import { REPORT_DATA,GET_REPORT_DATA
 } from "../actionTypes/ReportActionTypes";

const initialState = {
	reportData : null,
    existState : null
}

 const ReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORT_DATA:
            return {
                ...state,
                reportData: action.payload,
                existState: action.existState
            };  
        case GET_REPORT_DATA:
            return state.reportData;
        default:
            return state;
    }
    
}
export default  ReportReducer;